import {useEffect, useState} from "react";
import {MapContainer, Marker, Polygon, Popup, TileLayer, useMap} from "react-leaflet";
import {MarkerIcon} from "components/maps/icons";
import {CARTO_TILE_URL, CARTO_TILE_OPTIONS} from 'core/mapsConfig';
const ComponentResize = ({position, zoomDefault}) => {
    const map = useMap();

    useEffect(() => {
        map.setView(position, zoomDefault); // cambia la vista del mapa a la nueva posición
        map.invalidateSize(); // ajusta el tamaño del mapa a su contenedor.
    }, [position, map]);

    return null;
};

const MapBase = (props) => {
    const ZOOM = 13;
    const [position, setPosition] = useState(props.position);

    useEffect(() => {
        setPosition(props.position);
    }, [props.position]);

    return (
        <MapContainer
            center={position}
            zoom={ZOOM}
            scrollWheelZoom={false}
            style={{width: "100%", height: props.size ? props.size.height : "300px", zIndex: "2"}}>
            <ComponentResize position={position} zoomDefault={ZOOM} />
            <TileLayer
                url={CARTO_TILE_URL}
                {...CARTO_TILE_OPTIONS}
            />
            <Marker position={position} icon={MarkerIcon}>
                <Popup>
                    A pretty CSS3 popup. <br /> Easily customizable.
                </Popup>
            </Marker>
            {props.polyline && props.polyline.length > 0 && (
                <Polygon
                    positions={props.polyline}
                    pathOptions={{color: "#959595", fillColor: "#878787", fillOpacity: 0.2, weight: 2}}
                />
            )}
        </MapContainer>
    );
};

export default MapBase;
